import {FCWithHTMLAttributes} from "../types/reactTypes";
import {
	Button as RACLibraryButton,
	ButtonProps as RACButtonProps,
} from "react-aria-components";
import {
	ButtonVariantProps,
	ButtonSizes,
	ButtonVariant,
	buttonStyles,
} from "./Button";
import clsMerge from "../util/clsMerge";

/**
 * This is in a separate file from Button.tsx because it has to be a client component,
 * due to the restrictions of the RAC library.
 * https://react-spectrum.adobe.com/react-aria/Button.html
 */
const RACButton: FCWithHTMLAttributes<RACButtonProps & ButtonVariantProps> = ({
	children,
	className = "",
	variant = ButtonVariant.PRIMARY,
	size = ButtonSizes.LARGE,
	...props
}) => (
	<RACLibraryButton
		className={clsMerge(buttonStyles({variant, size}), className)}
		{...props}
	>
		{children}
	</RACLibraryButton>
);

export default RACButton;
